export default __webpack_public_path__ + "static/media/q-ass.700da5dd.svg";